module.exports = __webpack_public_path__ + "static/media/just_logo.bebbda23.png";